<template>
	<AdditionalLayout :title="`FAQ: ${group.title}`">
		<section class="section section--mini screen-start faq">
			<Question :title="question.question" class="faq__item" v-for="(question, i) in group.questions" :key="i">
				{{ question.answer }}
			</Question>
		</section>
	</AdditionalLayout>
</template>
<script lang="ts" setup>
import "./FaqCategoryView.scss";
import faqs from "./../faqs";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import Question from "@/components/Question/Question.vue";
import { useRoute } from 'vue-router'

let route = useRoute();

let group = faqs[+route.params.group];
</script>